import { useMutation, useQuery } from '@tanstack/react-query';
import queryClient from 'src/services/queryClient';
import { CreateSubDTO } from 'src/types';

import { getSubscribe, subscribe } from '../subscribe';

export function useSubscribeToOrganizer() {
  return useMutation({
    mutationFn: async (data: CreateSubDTO) => subscribe(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['subscribe'] });
    },
  });
}

export function useGetIsSubscribed(email: string, orgId: string) {
  return useQuery({
    queryKey: ['subscribe', orgId, email],
    queryFn: async () => getSubscribe({ email }, orgId),
    refetchInterval: 15000,
    enabled: !!email && !!orgId,
    refetchOnWindowFocus: true,
  });
}
